const profile = {
    link_account: {
        anonymous: 'Anonimowy',
    },
    delete_account: {
        title: 'USUŃ KONTO',
        label: 'Usuń konto',
        description: 'Usunięcie twojego konta spowoduje usunięcie wszystkich twoich danych osobistych, danych użytkownika i konfiguracji. Ta operacja nie może być cofnięta.',
        button: 'Usuń konto',
        p: {
            has_issue: 'Przykro nam, że chcesz usunąć swoje konto. Przed usunięciem konta musisz rozwiązać następujące problemy.',
            after_resolved: 'Po rozwiązaniu problemów, możesz usunąć swoje konto. Prosimy o kontakt, jeśli potrzebujesz pomocy.',
            check_information: 'Przykro nam, że chcesz usunąć swoje konto. Proszę dokładnie sprawdzić poniższe informacje przed kontynuowaniem.',
            remove_all_data: 'Usunięcie konta spowoduje trwałe usunięcie wszystkich danych o Tobie w Logto Cloud. Upewnij się, że masz kopię zapasową ważnych danych przed kontynuowaniem.',
            confirm_information: 'Proszę potwierdzić, że powyższe informacje są zgodne z Twoimi oczekiwaniami. Po usunięciu konta nie będziemy mogli go odzyskać.',
            has_admin_role: 'Ponieważ masz rolę administratora w poniższym najemcy, zostanie on usunięty wraz z Twoim kontem:',
            has_admin_role_other: 'Ponieważ masz rolę administratora w poniższych najemcach, zostaną one usunięte wraz z Twoim kontem:',
            quit_tenant: 'Zamierzasz opuścić poniższego najemcę:',
            quit_tenant_other: 'Zamierzasz opuścić poniższych najemców:',
        },
        issues: {
            console_sso: 'Przed usunięciem konta usuń wszystkie należące do niego konektory Console SSO.',
            paid_plan: 'Poniższy najemca ma płatny plan, proszę najpierw anulować subskrypcję:',
            paid_plan_other: 'Poniżsi najemcy mają płatne plany, proszę najpierw anulować subskrypcję:',
            subscription_status: 'Poniższy najemca ma problem ze statusem subskrypcji:',
            subscription_status_other: 'Poniżsi najemcy mają problemy ze statusem subskrypcji:',
            open_invoice: 'Poniższy najemca ma otwartą fakturę:',
            open_invoice_other: 'Poniżsi najemcy mają otwarte faktury:',
        },
        error_occurred: 'Wystąpił błąd',
        error_occurred_description: 'Przepraszamy, wystąpił problem podczas usuwania Twojego konta:',
        request_id: 'ID żądania: {{requestId}}',
        try_again_later: 'Spróbuj ponownie później. Jeśli problem będzie się powtarzał, skontaktuj się z zespołem Logto, podając ID żądania.',
        final_confirmation: 'Ostateczne potwierdzenie',
        about_to_start_deletion: 'Zaraz rozpoczniesz proces usuwania i tej operacji nie można cofnąć.',
        permanently_delete: 'Usuń na stałe',
    },
    fields: {
        name: 'Imię i nazwisko',
        name_description: 'Pełna nazwa użytkownika w formie wyświetlanej, obejmująca wszystkie części nazwy (np. "Jan Kowalski").',
        avatar: 'Awatar',
        avatar_description: 'URL obrazu awatara użytkownika.',
        familyName: 'Nazwisko',
        familyName_description: 'Nazwisko użytkownika (np. "Kowalski").',
        givenName: 'Imię',
        givenName_description: 'Imię użytkownika (np. "Jan").',
        middleName: 'Drugie imię',
        middleName_description: 'Drugie imię użytkownika (np. "Maria").',
        nickname: 'Pseudonim',
        nickname_description: 'Nieformalna lub potoczna nazwa użytkownika, która może różnić się od jego prawdziwego imienia i nazwiska.',
        preferredUsername: 'Preferowana nazwa użytkownika',
        preferredUsername_description: 'Skrócony identyfikator, którym użytkownik chce być określany.',
        profile: 'Profil',
        profile_description: 'URL czytelnej dla człowieka strony profilu użytkownika (np. profil w mediach społecznościowych).',
        website: 'Strona internetowa',
        website_description: 'URL osobistej strony internetowej lub bloga użytkownika.',
        gender: 'Płeć',
        gender_description: 'Samookreślona płeć użytkownika (np. "Kobieta", "Mężczyzna", "Niebinarna").',
        birthdate: 'Data urodzenia',
        birthdate_description: 'Data urodzenia użytkownika w określonym formacie (np. "DD-MM-RRRR").',
        zoneinfo: 'Strefa czasowa',
        zoneinfo_description: 'Strefa czasowa użytkownika w formacie IANA (np. "Europe/Warszawa" lub "America/New_York").',
        locale: 'Język',
        locale_description: 'Język użytkownika w formacie IETF BCP 47 (np. "pl-PL" lub "en-US").',
        address: {
            formatted: 'Adres',
            streetAddress: 'Ulica',
            locality: 'Miasto',
            region: 'Województwo',
            postalCode: 'Kod pocztowy',
            country: 'Kraj',
        },
        address_description: 'Pełny adres użytkownika w formie wyświetlanej, obejmujący wszystkie części adresu (np. "ul. Główna 1, 00-001 Warszawa, Polska").',
        fullname: 'Pełne imię i nazwisko',
        fullname_description: 'Elastycznie łączy nazwisko, imię i drugie imię w zależności od konfiguracji.',
    },
};
export default Object.freeze(profile);
